import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarCheck, MessageCircle, CheckCircle2, ArrowRight } from "lucide-react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Footer";

const BENEFITS = [
  "Walk through your documents together, section by section",
  "Get answers on your Capital Readiness Score and what to fix",
  "Leave with a clear plan for approaching the right funders",
];

export default function AdvisorBooking() {
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    document.title = "Book a Free Advisor Session | Clinq";
    window.scrollTo(0, 0);
    setAuthed(Boolean(localStorage.getItem("clinq_auth_token")));
  }, []);

  return (
    <div data-testid="advisor-booking-page" className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-black px-4 py-16 text-white sm:px-6 sm:py-24">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
          <img
            src="/david-avatar.jpg"
            alt="David, Clinq Advisor"
            data-testid="advisor-avatar"
            className="h-28 w-28 rounded-full border-4 border-[#0A8B85] object-cover shadow-[0_20px_60px_-15px_rgba(10,139,133,0.6)]"
          />
          <h1
            style={{ fontFamily: "'Raleway', sans-serif" }}
            className="mt-7 text-4xl font-bold tracking-tight sm:text-5xl"
          >
            Book a free session with a <span className="text-[#2DD4BF]">Clinq advisor</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/75">
            Stuck on a document? Not sure what funders want? You don&apos;t have to figure it out
            alone. Your first 30-minute advisor session is on us — we&apos;ll walk through it
            together and help you finish what you started.
          </p>

          <ul className="mt-8 space-y-3 text-left">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5 text-sm text-white/85">
                <CheckCircle2 className="mt-0.5 h-4.5 w-4.5 h-5 w-5 flex-shrink-0 text-[#2DD4BF]" />
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <button
              data-testid="advisor-book-btn"
              onClick={() => navigate(authed ? "/founder/tutorial?book=1" : "/join?next=advisor")}
              className="inline-flex items-center gap-2 rounded-md bg-[#0A8B85] px-6 py-3.5 text-base font-bold text-white transition-colors hover:bg-[#066667]"
            >
              <CalendarCheck className="h-5 w-5" />
              {authed ? "Book my free session" : "Sign in to book my free session"}
              <ArrowRight className="h-5 w-5" />
            </button>
            <a
              data-testid="advisor-whatsapp-link"
              href="https://wa.me/254119697109"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-md border border-white/25 px-6 py-3.5 text-base font-bold text-white/90 transition-colors hover:bg-white/10"
            >
              <MessageCircle className="h-5 w-5 text-[#2DD4BF]" /> Or message us on WhatsApp
            </a>
          </div>
          <p className="mt-5 text-xs text-white/50">
            Free for your first session · No card required · We usually confirm within one business day
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
